//used only on updated details page right now
var prodScroller = function () {

    function initScroller(sid){
    	 $(sid +" .Scroller").slick({ 		
            dots: false,
            infinite: false,
            speed: 500,
            slidesToShow: 5,
            slidesToScroll: 5,
            lazyLoad: 'ondemand',
            
            responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 4
                }
            },
            {
                breakpoint: 700,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            }]
         });     
    }
    
    function initScrollerMain(){
    	 $("#photoSwipeBox").slick({ 
    	     dots:true,
            infinite: true,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1,
            lazyLoad: 'ondemand',
            appendArrows: '#photoSwipeBoxWrapper',
            prevArrow: '<button id="leftArrowClick" role="button" type="button" aria-label="Previous Image" class="slick-prev">Previous</button>',
            nextArrow: '<button id="rightArrowClick" role="button" type="button" aria-label="Next Image" class="slick-next">Next</button>'
        });
    }
    
    
    var initProductColorScroller = function() {
        initScroller("#productColors");
    }
    
    var initRelatedItemsScroller = function() {
    	initScroller("#RelatedItems");
    }
    
    var initAltRelatedItemsScroller = function() {
    	initScroller("#altrelated");
    }
    
    var initAltItemsScroller = function() {
    	initScroller("#altitemslist");
    }
    
    var initScrollerTabProd = function() {
    	initScroller("#tabs");
    }

    //initialize tabs
    var initTabs = function() {
        var panelWidth;
        $("#tabs").tabs({
            active: 0,
            create: function (event, ui) {
                var tabNumber = $(".ui-tabs-nav li").length;
                $(".ui-tabs-nav li").width((100/tabNumber)+"%");
                $("#tabs").css("visibility", "visible");
                panelWidth = $("#tabs").width() > 0 ? $("#tabs").width() - 25 : panelWidth;
                //$(".ui-tabs-nav li").attr("tabindex", "0");
            },
            activate: function (event, ui) {
                var scroller = ui.newPanel.find(".Scroller");
                scroller[0].slick.setPosition(); 
                scroller.width(100+"%");			 
              }
        });
    }

    return{
        InitRelatedItemsScroller: initRelatedItemsScroller,
        InitProductColorScroller: initProductColorScroller,
        InitScrollerTabProd: initScrollerTabProd,
        InitTabs:  initTabs,
        InitAltRelatedItemsScroller:  initAltRelatedItemsScroller,
        InitAltItemsScroller:  initAltItemsScroller,
        InitScrollerMain: initScrollerMain
    };
};